import * as React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Grid, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { WebsiteTopVisitedPageSummary } from '../dataObjects/WebsiteTopVisitedPageSummary';
import { formatSecondsToMinutes } from '../../../utility/formatSecondsToMinutes';

interface topVisitedPageProps {
    pages?: WebsiteTopVisitedPageSummary[];
}

const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#fafafa',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const WebsiteTopVisitedPagesSummaryTable = (props: topVisitedPageProps) => {

    return (
        <>
            <Typography variant="h6" component={"h6"} gutterBottom>
                TOP 10 MOST VISITED PAGES 
            </Typography>
            <Grid item xs={10}>
                {
                    props.pages && props.pages.length > 0 &&
                    <TableContainer>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#FFFFFF' }}>
                                    <TableCell><Typography variant='caption' fontWeight={550}>PAGE</Typography></TableCell>
                                    <TableCell sx={{ textAlign: "right!important" }} ><Typography variant='caption' fontWeight={550}>VIEWS</Typography></TableCell>
                                    <TableCell sx={{ textAlign: "right!important" }} ><Typography variant='caption' fontWeight={550}>USERS</Typography></TableCell>
                                    <TableCell sx={{ textAlign: "right!important" }} ><Typography variant='caption' fontWeight={550}>AVERAGE TIME PER USER</Typography></TableCell>
                                </TableRow>
                            </TableHead>
                                <TableBody>
                                    {props.pages.map((page: WebsiteTopVisitedPageSummary, index) =>
                                    <StyledTableRow key={index}>
                                            <TableCell>
                                                <Typography variant="body2" fontWeight={550} >{page.title}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={1} display="flex" justifyContent="flex-end" >
                                                    <Typography variant="body2" align="right">{page.views}</Typography>
                                                    <Typography variant="body2" color={'text.secondary'} align="right">(<i>{page.percent}%</i>)</Typography>
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2" align="right">{page.users}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2" align="right">{formatSecondsToMinutes(page.averageUser)}</Typography>
                                            </TableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </Grid>
        </>
    );
}

export default WebsiteTopVisitedPagesSummaryTable 